import DashboardBox from '../../components/DashboardBox';
import BoxHeader from '../../components/BoxHeader';
import FlexBetween from '../../components/FlexBetween';
import { Box, Typography, useTheme } from "@mui/material";
import { DataGrid, GridCellParams } from "@mui/x-data-grid";
import React, { useMemo } from "react";
import { Cell, Pie, PieChart } from "recharts";

const pieChartData = [
  [
    { name: "Category 1", value: 300 },
    { name: "Category 2", value: 200 },
    { name: "Category 3", value: 100 },
  ],
  [
    { name: "Category X", value: 500 },
    { name: "Category Y", value: 100 },
    { name: "Category Z", value: 300 },
  ],
];


const Row3 = (props) => {
  const { palette } = useTheme();
  const pieColors = [palette.red[800], palette.blue[500]];
  const productData = props.product_data.product_data
  const transactionData = props.product_data.transaction_data
  console.log(productData)
  const productColumns = [
    {
      field: "id",
      headerName: "id",
      flex: 1,
    },
    {
      field: "expense",
      headerName: "Expense",
      flex: 0.5,
      renderCell: (params: GridCellParams) => `${params.value}`,
    },
    {
      field: "price",
      headerName: "Price",
      flex: 0.5,
      renderCell: (params: GridCellParams) => `${params.value}`,
    },
  ];

  const transactionColumns = [
    {
      field: "id",
      headerName: "id",
      flex: 1,
    },
    {
      field: "buyer",
      headerName: "Buyer",
      flex: 0.67,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 0.35,
      renderCell: (params: GridCellParams) => `$${params.value}`,
    },
    {
      field: "productIds",
      headerName: "Count",
      flex: 0.1,
      renderCell: (params: GridCellParams) => {
        const productIds = params.value;
        return productIds.length;
      },
    },
  ];
  
  const transactionDataGridStyles = {
    root: {
      "& .MuiDataGrid-root": {
        color: palette.grey[300],
        border: "none",
      },
      "& .MuiDataGrid-cell": {
        borderBottom: `1px solid ${palette.grey[800]} !important`,
      },
      "& .MuiDataGrid-columnHeaders": {
        borderBottom: `1px solid ${palette.grey[800]} !important`,
      },
      "& .MuiDataGrid-columnSeparator": {
        visibility: "hidden",
      },
    },
    columnMenu: {
      background: "#fff", // Set the background color for the column menu
      color: "#121212", // Set the text color for the column menu
    },
    filterPopover: {
      // Style the filter options popup window here
      backgroundColor: "#ffffff", // Set the background color
      color: "#000000", // Set the text color
    },
  };

  return (
    <>
    <DashboardBox gridArea="g">
    <BoxHeader
          title="List of Products"
          sideText={`${productData?.length} products`}
        />
        <Box
          mt="0.5rem"
          p="0 0.5rem"
          height="75%"
          sx={{
            "& .MuiDataGrid-root": {
              color: palette.grey[300],
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: `1px solid ${palette.grey[800]} !important`,
            },
            "& .MuiDataGrid-columnHeaders": {
              borderBottom: `1px solid ${palette.grey[800]} !important`,
            },
            "& .MuiDataGrid-columnSeparator": {
              visibility: "hidden",
            },
          }}
        >
          <DataGrid
            columnHeaderHeight={25}
            rowHeight={35}
            hideFooter={true}
            rows={productData || []}
            columns={productColumns}
            classes={transactionDataGridStyles}
          />
        </Box>
    </DashboardBox>
    <DashboardBox gridArea="h">
    <BoxHeader
          title="Recent Orders"
          sideText={`${transactionData?.length} latest transactions`}
        />
        <Box
          mt="1rem"
          p="0 0.5rem"
          height="80%"
          sx={{
            "& .MuiDataGrid-root": {
              color: palette.grey[300],
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: `1px solid ${palette.grey[800]} !important`,
            },
            "& .MuiDataGrid-columnHeaders": {
              borderBottom: `1px solid ${palette.grey[800]} !important`,
            },
            "& .MuiDataGrid-columnSeparator": {
              visibility: "hidden",
            },
          }}
        >
          <DataGrid
            columnHeaderHeight={25}
            rowHeight={35}
            hideFooter={true}
            rows={transactionData || []}
            columns={transactionColumns}
            
          />
        </Box>
    </DashboardBox>
    <DashboardBox gridArea="i">
  <BoxHeader title="Expense Breakdown By Category" sideText="+4%" />
  <FlexBetween mt="0.5rem" gap="0.5rem" p="0 1rem" textAlign="center">
    {pieChartData?.map((data, i) => ( // Corrected this line
      <Box key={`${data[0].name}-${i}`}>
        <PieChart width={110} height={100}>
          <Pie
            stroke="none"
            data={data}
            innerRadius={18}
            outerRadius={35}
            paddingAngle={2}
            dataKey="value"
          >
            {data.map((entry, index) => ( // This line is correct
              <Cell key={`cell-${index}`} fill={pieColors[index]} />
            ))}
          </Pie>
        </PieChart>
    
      </Box>
    ))}
  </FlexBetween>
</DashboardBox>
    <DashboardBox gridArea="j">
    <BoxHeader
          title="More Updates coming soon."
       
        />
        <Box
          height="15px"
          margin="0.1rem 0.1rem 0.1rem 0.11rem"
          bgcolor={palette.primary[800]}
          borderRadius="1rem"
        >
          <Box
            height="15px"
            bgcolor={palette.primary[600]}
            borderRadius="1rem"
            width="40%"
          ></Box>
        </Box>
        <Typography margin="0 1rem" variant="subtitle2">
          Bizzence Collab - Elevating your Business sense and Science.
        </Typography>
      </DashboardBox>
    </>
  )
}

export default Row3